<app-patient-visit-detail 
    [visit]="visit" 
    [hasButtonBack]="true" 
    (onButtonBack)="handleButtonBack( $event )"
    [hasButtonEdit]="true" 
    (onButtonEdit)="handleButtonEdit( $event )"
    [filterFields]="true">
</app-patient-visit-detail>
